module.exports = __webpack_public_path__ + "img/icon-web-logo.20180735.png";